import _Promise from "@babel/runtime-corejs3/core-js/promise";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileAvatar from "@Shared/components/general/profile-avatar.vue";
import PictureCropper from "@Shared/components/modals/picture-cropper/picture-cropper.vue";
import DOMPurify from "dompurify";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ProfilePicture",
  components: {
    ProfileAvatar,
    PictureCropper
  },
  props: {
    userDetails: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      file: null,
      openPhotoCropper: false
    };
  },
  methods: {
    async handleFileUpload() {
      this.file = this.$refs.file.files[0];
      if (this.file.type == "image/svg+xml") {
        this.file = await this.sanitizeFile(this.file);
      }
      if (!this.file) return;
      this.openPhotoCropper = true;
      await this.$nextTick();
      this.$refs.pictureCropperModal.$showModal();
    },
    async sanitizeFile(file) {
      const fileContent = await new _Promise(resolve => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsText(file);
      });
      const sanitizedContent = DOMPurify.sanitize(fileContent);
      return new File([sanitizedContent], file.name, {
        type: file.type,
        lastModified: file.lastModified
      });
    },
    clearFileSelect() {
      this.openPhotoCropper = false;
      this.$nextTick(() => {
        this.$refs.file.value = "";
        this.file = null;
      });
    },
    async handlePictureCropped(croppedImage) {
      this.$emit("submit-upload", croppedImage);
    },
    async handleRemovePhoto() {
      this.$emit("submit-remove");
    }
  }
});